import React from "react";
import { degToRad } from "../../astronomy/kepler";

interface AxialTiltIndicatorProps {
  axialTiltDeg: number;
  length: number;
  visible: boolean;
}

export function AxialTiltIndicator({
  axialTiltDeg,
  length,
  visible,
}: AxialTiltIndicatorProps) {
  if (!visible) return null;

  return (
    <group rotation={[0, 0, degToRad(axialTiltDeg)]}>
      <mesh>
        <cylinderGeometry
          args={[length * 0.015, length * 0.015, length * 2, 8]}
        />
        <meshBasicMaterial color="#66ffaa" transparent opacity={0.65} />
      </mesh>
    </group>
  );
}
